import { Component } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from 'environments/environment';
import { AuthService } from '../../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../_services/loader.service'; 
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import Swal from 'sweetalert2'
import { utils, write, WorkBook } from 'xlsx';  
import { saveAs } from 'file-saver'; 
import { process, State, aggregateBy } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { Observable } from 'rxjs/Observable';
import { SelectableSettings, DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';

const distinctVehType = data => data.filter((x, idx, xs) => xs.findIndex(y => y.VEHTYPNAME === x.VEHTYPNAME) === idx);
const distinctVehCategory = data => data.filter((x, idx, xs) => xs.findIndex(y => y.VEHCATNAME === x.VEHCATNAME) === idx);

declare var $: any;
 
@Component({
  templateUrl: './vtsDailyReport.component.html',
})

export class VtsDailyReportComponent {
  public prjId: any
  public userId: any
  public startDate: any
  public endDate: any
  public defaultStartDate: any
  public defaultEndDate: any
  public dataRangeModal: any
  public showLoader: boolean
  public vehVtsDailyList: any  
  public vtsDataNotFound=false  
  public search:any;
  public selectableSettings: SelectableSettings;
  public selectedRow : Number;
  public gridVtsDailyReport: DataResult;
  public distinctVehType: any[]
  public distinctVehCategory: any[]
  public state: State = {
    skip: 0,
    take: 20,
    filter: {
      logic: 'and',
      filters: []
    }
  };
  syncing: boolean;
  loaderClass: string;
  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.vehVtsDailyList
    };
    return result;
  }
  public groups: GroupDescriptor[] = [];
  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }
  private loadProducts(): void {
    this.gridVtsDailyReport = process(this.vehVtsDailyList, { group: this.groups });
  }
  constructor(private http : HttpClient , private auth: AuthService, public routes: ActivatedRoute, public router: Router, private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    }); 
    var date = new Date();
    this.defaultStartDate = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.defaultEndDate = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.dataRangeModal = { beginDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate()-1 }, endDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate()-1 } };
   }

    /*
    * Get VEHICLE HISTORY DEATILS 
    */
    getVtsDailyReport() {
        this.loaderService.display(true);
        this.http.get(environment.apiUrl + 'reports/getVtsDailyReport?prjId=' + this.prjId + "&startDate=" + this.startDate + "&endDate=" + this.endDate).subscribe(data => {
        this.vehVtsDailyList = data
        if (this.vehVtsDailyList.length > 0) {  
            this.loaderService.display(false);
            this.vtsDataNotFound=false
            this.gridVtsDailyReport = process(this.vehVtsDailyList, this.state);
            this.distinctVehCategory = distinctVehCategory(this.vehVtsDailyList)
            this.distinctVehType = distinctVehType(this.vehVtsDailyList)
        } else { 
            this.loaderService.display(false);
            this.vtsDataNotFound=true;
            this.gridVtsDailyReport=null
        }},
        error => {
            this.loaderService.display(false);
            Swal({
            type: 'error',
            title: 'Oops...',
            text: 'An Error Occurred Please Try Again',
            })
        });
    }

    /*
   * filter The Grid Data
  */
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridVtsDailyReport = process(this.vehVtsDailyList, this.state);
    if (state && state.group) {
      // this.distinctFuelType = distinctFuelType(this.fuelReportList)
      this.distinctVehCategory = distinctVehCategory(this.vehVtsDailyList)
      this.distinctVehType = distinctVehType(this.vehVtsDailyList)
      this.gridVtsDailyReport = process(this.vehVtsDailyList, this.state);
    }
  }


    /*
    *select start Date Nad To date
    */
    onDateRangeChanged(dataRange) {
        if (dataRange.beginDate.day > 0) {
        this.startDate = dataRange.beginDate.year + "-" + dataRange.beginDate.month + "-" + dataRange.beginDate.day
        this.endDate = dataRange.endDate.year + "-" + dataRange.endDate.month + "-" + dataRange.endDate.day
        this.getVtsDailyReport();
        }
        else if (dataRange.beginDate.day == 0) {
        this.startDate = this.defaultStartDate
        this.endDate = this.defaultEndDate
        this.getVtsDailyReport();
        }
    }

    // sync data
    syncData() {
      this.syncing = true
      this.loaderClass = 'fas fa-sync fa-spin'
      this.http.get(environment.apiUrl + 'reports/getVtsDailyReport?prjId=' + this.prjId + "&startDate=" + this.startDate + "&endDate=" + this.endDate).subscribe(data => {
       // this.fuelReportList = data;
        this.syncing = false
        this.loaderClass = 'fas fa-sync'
        this.getVtsDailyReport();
      })
  
    }
        
    /*
    * This Method Is use to Download the Vehicles Report into Excel File 
    */
    importVtsDailyReport(vehVtsDailyList){
    const ws_name = 'VtsReport';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(vehVtsDailyList);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 
    'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'VtsReport.xlsx');
    }s2ab(s){
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
        };
        return buf;
    } 


    /*
     * Get Index and Select Table Row
     */
    selectRowIndex(data,index){
      this.selectedRow=index;
    }




  ngOnInit() {
    this.prjId = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id
    this.startDate = moment(this.defaultStartDate).subtract(1, 'day').format('YYYY-MM-DD');
    this.endDate = moment(this.defaultEndDate).subtract(1, 'day').format('YYYY-MM-DD');
    this.getVtsDailyReport();
    this.selectableSettings = {
      mode: 'multiple',
    };
  }
}


// WEBPACK FOOTER //
// ./src/app/reports/vtsReport/vtsDailyReport.component.ts